import {
  classifyReturnsRouting,
  RETURNS_ROUTING_DECISION_STEP_ID,
  type ReturnsRoutingClassification,
} from "@redotech/redo-onboarding-api/returns-routing";
import type { SaveProgressRpc } from "./rpc-client";

export type ReturnsRoutingDecision = ReturnsRoutingClassification &
  Record<string, unknown> & {
    totalAnnualOrderVolume: number | null;
    provisionalOrderCount30d: number | null;
    decidedAt: string;
  };

export function buildReturnsRoutingDecision(
  totalAnnualOrderVolume: number | null,
  provisionalOrderCount30d: number | null,
  decidedAt = new Date().toISOString(),
): ReturnsRoutingDecision {
  return {
    ...classifyReturnsRouting(totalAnnualOrderVolume, provisionalOrderCount30d),
    totalAnnualOrderVolume,
    provisionalOrderCount30d,
    decidedAt,
  };
}

export async function persistReturnsRoutingDecision(options: {
  currentStepId: string;
  decision: ReturnsRoutingDecision;
  rpcClient: SaveProgressRpc;
  track(decision: ReturnsRoutingDecision): void;
}): Promise<boolean> {
  const result = await options.rpcClient.saveProgress({
    productId: "returns",
    currentStepId: options.currentStepId,
    sourceStepId: RETURNS_ROUTING_DECISION_STEP_ID,
    stepData: options.decision,
    stepDataWriteMode: "set-if-absent",
  });

  if (!result.stepDataWritten) {
    return false;
  }

  options.track(options.decision);
  return true;
}
